import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from './cliente';
import { chaves } from './query';
import type { Diagnostico, NovoDiagnostico } from './tipos';

/* Diagnóstico = fotografia do relatório no momento em que foi gerado.
 *
 * O comentário anterior dizia "alertas que o servidor levanta", o que nunca foi
 * verdade: a tabela guarda o snapshot do laudo, e é a tela do relatório que
 * grava. Alerta de configuração é outra coisa e vive no cálculo. */

export function useDiagnosticos() {
  return useQuery({
    queryKey: chaves.diagnosticos,
    queryFn: () => api.obter<Diagnostico[]>('/diagnosticos'),
  });
}

/**
 * Arquiva o relatório recém-gerado.
 *
 * Existe para o relatório não precisar chamar `api.criar` direto: componente
 * que fala HTTP na mão é a porta de entrada para o contrato divergir sem
 * ninguém notar, que já aconteceu cinco vezes neste projeto.
 */
export function useSalvarDiagnostico() {
  const clienteQuery = useQueryClient();
  return useMutation({
    mutationFn: (dados: NovoDiagnostico) => api.criar<Diagnostico>('/diagnosticos', dados),
    onSuccess: () => void clienteQuery.invalidateQueries({ queryKey: chaves.diagnosticos }),
  });
}
